module.exports = __webpack_public_path__ + "cc98e19569b78a01e3dd6b3df36ca2b5.png";